/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#161616";
export const ColorTextSecondary = "#FFFFFF";
export const ColorBackgroundPrimary = "#3BD1CD";
export const ColorBackgroundSecondary = "#3BD1CD";
export const ColorIconPrimary = "#161616";
export const ColorIconSecondary = "#FFFFFF";
export const ColorBorderPrimary = "rgba(14,24,54,0.5)";
export const ColorBorderSecondary = "rgba(60,77,129,0.2)";
